import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useDispatch } from 'react-redux';
import { FontAwesome } from '@expo/vector-icons';
import PressableStyled from '../../../../../components/PressableStyled';
import Style from '../../../../../constants/Style';
import Colors from '../../../../../constants/Colors';
import isMobile from '../../../../../components/IsMobile';
import { updateTicketsFilterAssetId, updateTicketsFilterAssetName } from '../../../../../redux/ticketsFilterSlice';
import { AppScreen } from '../../../../../navigation/LinkingConfiguration';
import { AssetInstance } from '../../../../../constants/Types';

interface TicketsLogProps {
  asset: AssetInstance,
  ticketCount: number | undefined,
}

const TicketsLog = ({ asset, ticketCount }: TicketsLogProps) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const navigateToTickets: () => void = () => {
    dispatch(updateTicketsFilterAssetId(asset.id));
    dispatch(updateTicketsFilterAssetName(asset.name));
    navigation.navigate(AppScreen.TICKETS as any);
  };

  return <View style={styles.container}>
    <View style={Style.row}>
      <Text style={styles.text}>
        {'Tickets raised against asset'}
      </Text>
      <PressableStyled
        style={Style.row}
        onPress={navigateToTickets}
      >
        <Text style={[styles.text, styles.viewLogText]}>{'View log'}</Text>
        <FontAwesome
          name='angle-right'
          size={16}
          color={styles.viewLogText.color}
        />
      </PressableStyled>
    </View>
    <View style={styles.ticketCountContainer}>
      <Text style={[styles.text, styles.ticketCount]}>{ticketCount ?? '-'}</Text>
      <Text style={styles.text}>{'Tickets'}</Text>
    </View>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: isMobile ? 8 : 16,
    borderBottomWidth: 1,
    borderBottomColor: Colors.light.hereworksBlue100,
    marginBottom: 16,
    marginTop: isMobile ? 0 : 24,
  },
  text: {
    fontSize: 14,
    lineHeight: 18,
    fontFamily: 'Roboto_400Regular',
    letterSpacing: 0,
    color: Colors.light.hereworksBlack600,
  },
  viewLogText: {
    color: Colors.light.hereworksBlue500,
    marginEnd: 8,
  },
  ticketCountContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginTop: 8,
  },
  ticketCount: {
    fontSize: 30,
    lineHeight: isMobile ? undefined : 30,
    maxHeight: isMobile ? 36 : 28,
    fontFamily: 'Poppins_600SemiBold',
    marginEnd: 4,
  },
});

export default TicketsLog;
